import(/* webpackMode: "eager" */ "/jandock/app/global-error.tsx");
